import React from 'react';
import styled from 'styled-components';

import LoginFormContainer from './LoginFormContainer';
import Banner from '../../common/components/layouts/Banner';

const LOGO_LEGALLAIS_URL = require('../../../assets/legallais.png');

const Page = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow-y: scroll;
`;

const Header = styled.header`
	position: relative;
	height: 300px;
`;

const Overlay = styled.div`
	position: absolute;
	top: 100px;
	width: 100%;
	height: 205px;
	padding: 16px;
	background-color: rgba(60, 60, 60, 0.9);
`;

const Title = styled.h1`
	font-size: 24px;
	font-weight: 500;
	color: #fff;
	text-align: center;
`;

const Subtitle = styled.h2`
	font-size: 20px;
	font-weight: 100;
	color: #fff;
	text-align: center;
`;

const ContentWrapper = styled.div`
	flex-shrink: 0;
	position: relative;
	display: flex;
	justify-content: center;
	margin-top: -100px;
`;

const Footer = styled.footer`
	margin-top: auto;
	padding: 10px;
	text-align: center;
	font-size: 14px;
	font-weight: 500;
`;

const LoginRoute = () => (
	<Page>
		<Header>
			<Banner />
			<Overlay>
				<Title>Bienvenue sur Capitaine Clés !</Title>
				<Subtitle>
					Merci de vous identifier avec vos identifiants Legallais
				</Subtitle>
			</Overlay>
		</Header>
		<ContentWrapper>
			<LoginFormContainer />
		</ContentWrapper>
		<Footer>
			Un outil pour créer vos organigrammes par
			<img src={LOGO_LEGALLAIS_URL} />
		</Footer>
	</Page>
);

export default LoginRoute;



// WEBPACK FOOTER //
// ./src/js/Login/client/LoginRoute.js